import React from 'react'

const FooterStarpath = () => {
  return (
    <footer className="home-six-footer">
        <div className="footer-top footer-bg">
          <div className="newsletter-area s-newsletter-area" style={{maxWidth: '512px', marginLeft: 'auto', marginRight:'auto', justifyContent: 'center'}}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="newsletter-wrap" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '16px', marginTop: '-32px'}}>
                    <a href="/"><img src="/assets/img/logo/w_logo.png" alt="Starpath"/></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-xl-2 col-lg-3 col-sm-6">
                <div className="footer-widget mb-50">
                  <div className="fw-title mb-35">
                    <h5>Experiences</h5>
                  </div>
                  <div className="fw-link">
                    <ul>
                      <li><a href="/shipyards">Ship Yards</a></li>
                      <li><a href="/galaxymap">Galaxy Map</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-sm-6">
                <div className="footer-widget mb-50">
                  <div className="fw-title mb-35">
                    <h5>Community</h5>
                  </div>
                  <div className="fw-link">
                    <ul>
                      <li><a href="/blogs">Blog</a></li>
                      <li><a href="/about-us">About Us</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer-widget mb-50">
                  <div className="fw-title mb-35">
                    <h5>Follow us</h5>
                  </div>
                  <div className="footer-social">
                    <ul>
                      <li><a href="https://yolan.itch.io/star-path-ship-builder" target="_blank" rel="noopener noreferrer"><i className="fab fa-itch-io" /></a></li>
                      <li><a href="https://discord.gg/starpath" target="_blank" rel="noopener noreferrer"><i className="fab fa-discord" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap s-copyright-wrap">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="copyright-text">
                  <p>Copyright &copy; {new Date().getFullYear()} <a href="https://doubtech.com" target="_blank" rel="noopener noreferrer">Doubling Technologies</a> All Rights Reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
  )
}

export default FooterStarpath
